(() => {
  const script = document.currentScript;
  const add = script.dataset.bundleAdd;
  const remove = script.dataset.bundleRemove;
  const updateChatPosition = () => {
    const root = document.getElementById('moosedesk-widget-host')?.shadowRoot;
    if (!root) return;
    const existing = root.getElementById('falfungi-bundle-chat-position');
    if (!document.querySelector('.sumi-product-card')) {
      existing?.remove();
      return;
    }
    if (existing) return;
    const style = document.createElement('style');
    style.id = 'falfungi-bundle-chat-position';
    style.textContent = '@media screen and (max-width: 749px) { .whatsapp-float-btn_container { bottom: calc(120px + env(safe-area-inset-bottom, 0px)) !important; } }';
    root.appendChild(style);
  };
  const update = () => {
    updateChatPosition();
    document.querySelectorAll('.sumi-product-card').forEach(card => {
      const title = card.querySelector('.sumi-product-title')?.textContent.trim();
      if (!title) return;
      card.querySelectorAll('button.sumi-add-to-bundle-button, button.sumi-remove-from-bundle-button').forEach(button => {
        const pattern = button.classList.contains('sumi-remove-from-bundle-button') ? remove : add;
        const label = pattern.replace('[product]', title);
        if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      });
    });
  };
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; update(); });
  });
  const main = document.body;
  if (main) observer.observe(main, { childList: true, subtree: true, characterData: true });
  update();
  let chatChecks = 0;
  const chatTimer = setInterval(() => {
    updateChatPosition();
    if (document.getElementById('moosedesk-widget-host')?.shadowRoot?.getElementById('falfungi-bundle-chat-position') || ++chatChecks >= 20) clearInterval(chatTimer);
  }, 500);
})();